import { get } from './http'

// 获取用户信息
export const getUserInfo = p => get('/index/index/getUserInfo', p);

// 邀请列表
export const teamInfo = p => get('/index/index/teamInfo', p);

// 收益记录
export const transferLog = p => get('/index/index/transferLog', p);

// 获取质押认购配置
export const yaConfig = p => get('/index/index/yaConfig', p);

// FTM涨幅
export const getConfig = p => get('/index/index/getConfig', p);

// 验证是否能参与质押
export const checkYa = p => get('/index/index/checkYa', p);

// 订单列表
export const orderList = p => get('/index/index/orderList', p);
